import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class RequestProvider {

  constructor(
    private afs: AngularFirestore
  ) { }

  getUserRequests(userId: string, clientId: string) {
    return this.afs.collection(clientId).doc('Request').collection(userId, ref => ref.where('status', '==', 'pending'))
      // return this.afDatabase.list<IRequest>(`/Clients/${clientId}/UserRequest`, ref => ref.orderByChild('requested').equalTo(userId))
      .valueChanges();
  }
}


// WEBPACK FOOTER //
// ./src/providers/request.ts